import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { StorageService } from 'src/app/services/storage.service';
import { LoginService } from '../services/login.service';
import { MsalService } from '@azure/msal-angular';
import { MessageService } from 'primeng/api';
import { ABCLLoginUrl, LoginFlowConstants } from '../models/user-login.model';
@Component({
    selector: 'app-cyberark',
    templateUrl: './cyberark.component.html',
    styleUrls: ['./cyberark.component.scss'],
    standalone: false
})
export class CyberarkComponent implements OnInit {
  abclLoginUrl: ABCLLoginUrl = new ABCLLoginUrl();
  loginConstants: LoginFlowConstants = new LoginFlowConstants();

  constructor(
    private router: Router,
    private cookieService: CookieService,
    private storageService: StorageService,
    private loginService: LoginService,
    private authService: MsalService,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.handleLogout();
  }
  handleLogout(): void {
    this.loginService.logout().subscribe((res) => {
      if (res.status === 200) {
        if (res.content.redirect_url) {
          const token = this.storageService.getABCLToken();
          let redirectUrl = res.content.redirect_url;
          if (token) {
            redirectUrl = `${redirectUrl}${token}`;
          }
          window.location.replace(redirectUrl);
        } else {
          this.router.navigateByUrl(this.abclLoginUrl.base_url);
        }
        this.cookieService.delete(this.loginConstants.role);
        this.cookieService.delete(this.loginConstants.accessToken);
        this.storageService.clearStorage();
        this.authService.instance.setActiveAccount(null);
      } else {
        this.messageService.add({
          severity: this.loginConstants.error,
          detail: this.loginConstants.wentWrongMessage,
        });
        this.router.navigateByUrl(this.abclLoginUrl.base_url);
        this.cookieService.delete(this.loginConstants.role);
        this.cookieService.delete(this.loginConstants.accessToken);
        this.storageService.clearStorage();
        this.authService.instance.setActiveAccount(null);
      }
    });
  }
}
